import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import FavoriteCircleLine from '@icons/favorite/FavoriteCircleLine';
import FavoriteLine from '@icons/favorite/FavoriteLine';
import { OrderItemRow } from '@models/order/orderLog';
import { useTranslation } from 'react-i18next';

import img from './img.png';
import MyMenuBottomSheet from './MyMenuBottomSheet';
import styles from './styles.module.scss';

interface Props {
    orderItem: OrderItemRow;
}
function OrderItem({ orderItem }:Props) {
    const { t } = useTranslation('orderLog');
    const {
        name, salePrice, thumbnailUrl, qty, orderOptions,
    } = orderItem;
    const { openBottomSheet } = useBottomSheet();
    const openMyMenuBottomSheet = () => {
        openBottomSheet('MY메뉴 추가', <MyMenuBottomSheet/>);
    };
    const optionAmount = orderOptions
        .map((option) => option.qty * option.salePrice)
        .reduce((prev, curr) => prev + curr, 0);
    const totalAmount = (salePrice + optionAmount) * qty;
    const priceUnit = usePriceUnit();
    return (
        <Column className={styles.container} fullWidth>
            <Row fullWidth spacing={16}
                className={styles.contents}
                align='flex-start'>
                <Column className={styles.image} justify='center' align='center'>
                    <Image src={thumbnailUrl}
                        width={72}
                        height={72}
                        alt={t('item.imageAlt')}/>
                    {/*
                    <button className={styles.heartWrapper}
                            onClick={openMyMenuBottomSheet}>
                        <FavoriteLine size={28}
                                       color={colors.gray6} />
                    </button>
                    */}
                </Column>
                <Column spacing={10} fullWidth>
                    <Column fullWidth>
                        <Text size='lg' fontWeight='bold' color={colors.gray8}
                            className={styles.name} >
                            {name}
                        </Text>
                        <Row fullWidth justify='space-between' align='center'>
                            <Text color={colors.gray8}>{t('item.quantity', { qty: qty.toLocaleString() })}</Text>
                            <Text size='lg' fontWeight='bold' color={colors.primary}>
                                {totalAmount.toLocaleString()}{priceUnit}
                            </Text>
                        </Row>
                    </Column>
                    <Column>
                        {orderOptions
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((option) => (
                                <Text color={colors.gray8}
                                    key={option.optionId}>
                                    {option.name}{t('item.optionPrice', { price: `${(option.qty * option.salePrice).toLocaleString()}${priceUnit}` })}
                                </Text>
                            ))}
                    </Column>
                </Column>
            </Row>
            <hr className={styles.divider}/>
        </Column>
    );
}

export default OrderItem;
